import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import styled from "styled-components";
import { DataContext } from "../../../contexts/DataContext";
import Input from "../../UI/Form/Input";
const Main = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const SelectContainer = styled(Select)`
  width: 40%;
  margin: 0.5em;
  width: ${(props) => (props.setSize ? "128px" : "")};
`;

export default function TeamSelect({
  season,
  homeFighter,
  awayFighter,
  onChangeHomeFighter,
  onChangeAwayFighter,
  numberOfRounds,
  roundMinutes,
  setNumberOfRounds,
  setRoundMinutes,
  commentators,
  setCommentators,
  mc,
  setMc,
}) {
  const [fighters, setFighters] = useState();

  useEffect(() => {
    setFighters(season?.fighters);
  }, [season]);
  return (
    <Main
    style={{flexDirection: "column"}}>
    <Main>
      <SelectContainer
        value={
          homeFighter && {
            value: homeFighter._id,
            label: homeFighter.first_name + " " + homeFighter.last_name,
          }
        }
        options={
          fighters &&
          fighters.map((t) => {
            return { value: t._id, label: t.first_name + " " + t.last_name };
          })
        }
        onChange={(e) => {
          onChangeHomeFighter(fighters.find((t) => t._id === e.value));
        }}
        placeholder="Select Home fighter"
      />
      v
      <SelectContainer
        value={
          awayFighter && {
            value: awayFighter._id,
            label: awayFighter.first_name + " " + awayFighter.last_name,
          }
        }
        options={
          fighters &&
          fighters.map((t) => {
            return { value: t._id, label: t.first_name + " " + t.last_name };
          })
        }
        onChange={(e) => {
          onChangeAwayFighter(fighters.find((t) => t._id === e.value));
        }}
        placeholder="Select Away fighter"
      />
      </Main>
      <Main>
    <Input
      title="Number of rounds"
      value={ numberOfRounds }
      placeholder="Number of Rounds"
      onChange={(e) => {
        setNumberOfRounds(e.target.value);
      }}
    />
    <Input
      title="Round minutes"
      value={ roundMinutes }
      placeholder=""
      onChange={(e) => {
        setRoundMinutes(e.target.value);
      }}
    />
    </Main>
    <Main>
      {new Array(3).fill(1)?.map((_, i) => {
        let comm = commentators?.[i];
        return (
          <div key={i} style={{display: "flex"}}>
          <Input
            title={"Commentator " + (i + 1) + " First Name"}
            value={comm?.first_name || ""}
            placeholder=""
            onChange={(e) => { 
              let updatedCommentators = [...commentators];
              let newCommentator = {
                ...comm,
                first_name: e.target.value,
              };
              updatedCommentators[i] = newCommentator
              setCommentators(updatedCommentators);
            }}
          />
          <Input
            title={"Commentator " + (i + 1) + " Last Name"} 
            value={comm?.last_name || ""}
            placeholder=""
            onChange={(e) => { 
              let updatedCommentators = [...commentators];
              let newCommentator = {
                ...comm,
                last_name: e.target.value,
              };
              updatedCommentators[i] = newCommentator
              setCommentators(updatedCommentators);
            }}
          />
          </div>
        );
      }
      )}
      </Main>
      <Main style={{width:"50%"}}>
      <Input
      value={mc?.first_name || ""}
      placeholder="MC First Name"
      onChange={(e) => {
        let mcobject = {...mc};
        mcobject.first_name = e.target.value;
        setMc(mcobject);
      }}
    />
    <Input
      value={mc?.last_name || ""}
      placeholder="MC Last Name"
      onChange={(e) => {
        let mcobject = {...mc};
        mcobject.last_name = e.target.value;
        setMc(mcobject);
      }}
    />
    </Main>
    </Main>
  );
}
